import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"

type OwnProps = {
    url: string
    exportedMainMessage: FormattedMessage | JSX.Element
    integrationLogo: {
        integrationKey: INTEGRATION_KEY,
        width: number
        height: number
    }
    buttonMessage: FormattedMessage | JSX.Element
}

const DocumentEventExportedComponent = (props: OwnProps) => {
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {props.exportedMainMessage}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={props.url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(
                            props.integrationLogo.integrationKey, 
                            props.integrationLogo.width, 
                            props.integrationLogo.height,
                        )}
                    </a>
                </div>
                {props.url &&
                    <div>
                        <p className={"mb-0"}>
                            <a href={props.url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                {props.buttonMessage}
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}


export default DocumentEventExportedComponent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/DocumentEventExportedComponent.tsx